import { gql } from "generated-graphql";

/**
 * Query to search tenants for autocomplete
 */
export const SEARCH_TENANTS_QUERY = gql(`
  query SearchTenants($search: String, $pageSize: Int, $sort: [SortModel!]) {
    tenants(search: $search, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
      }
      count
    }
  }
`);
